import { FC } from "react";
import classNames from "classnames";
import classes from "./Column.module.scss";

type ColumnType = {
  children: React.ReactNode;
  className?: string;
  width: number;
};

const Column: FC<ColumnType> = ({ children, className, width }) => {
  return (
    <div
      className={classNames(classes.column, `${className ?? ""}`)}
      style={{ flex: `0 0 ${width}%` }}
    >
      {children}
    </div>
  );
};

export default Column;
